export enum CurrencyCode {
  USD = 'USD',
  EUR = 'EUR',
}

export enum Currency {
  USD = '$',
  EUR = '€',
}
